import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Hook to generate an AI suggestion for an entity
 */
export function useGenerateAiSuggestion(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    ...orpc.ai.suggestions.generate.mutationOptions(),
    onSuccess: () => {
      // Invalidate AI suggestion queries using correct oRPC key
      queryClient.invalidateQueries({
        queryKey: orpc.ai.suggestions.get.key(),
      });
      queryClient.invalidateQueries({
        queryKey: ['accounts-receivable', 'sales-order-drafts'],
      });
      onSuccess?.();
    },
  });
}
